var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 32,
    viewBox: "0 0 21 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.942 4.184c1.136 0 2.058-.937 2.058-2.092C21 .936 20.08 0 18.942 0 12.332 0 6.666 4.162 4.336 10.041H2.059C.922 10.041 0 10.978 0 12.134c0 1.155.922 2.092 2.06 2.092h1.238a15.99 15.99 0 0 0 0 3.548H2.06C.922 17.774 0 18.711 0 19.866c0 1.156.922 2.092 2.06 2.092h2.276C6.666 27.838 12.333 32 18.942 32 20.078 32 21 31.064 21 29.908c0-1.155-.92-2.092-2.058-2.092-4.273 0-8.014-2.357-10.033-5.858h2.477c1.137 0 2.058-.936 2.058-2.092 0-1.155-.92-2.092-2.058-2.092h-3.94a12.068 12.068 0 0 1 0-3.548h3.94c1.137 0 2.058-.937 2.058-2.092 0-1.156-.92-2.093-2.058-2.093H8.909c2.02-3.5 5.76-5.857 10.033-5.857z",
    fill: "#3CC",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.cd87efb3fce3591a238aa245318cc194.svg";
export { ForwardRef as ReactComponent };